// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"catalog"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M3 3H21M8 3V21M16 9L8 9M16 15L8 15M16 21.0039H8","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2"},"nodeName":"g","children":[{"attributes":{"stroke":"currentColor","d":"M21 8.99609L20.9961 8.99609L19 9L21 9V8.99609Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M21 14.9961H20.9961L19 15H21V14.9961Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M21 21H20.9961L19 21.0039H21V21Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]}]};

@tag('t-icon-catalog-1')
export default class Catalog1Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'catalog-1',
    }
  }
}
